import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useLocation } from 'react-use';
import { postAsync, putAsync, reactURL } from '../../../components/helper/axiosHelper';
import { PageHitCountApi } from '../../../shared/Helper';

function ForgotPassword() {
  const [userName, setUserName] = useState('');
  const [mobile, setMobile] = useState('');
  const [isusername, setIsusername] = useState(false);
  const { pathname } = useLocation();

  const body = {
    userName,
    mobile: mobile?.toString(),
  };

  useEffect(() => {
    PageHitCountApi(pathname, 0);
  }, []);

  const validate = () => {
    let result = true;
    if ((userName === '' || userName === null) && (mobile === '' || mobile === null)) {
      result = false;
      setMobile('');
      setUserName('');
      toast.warning(`${t('msg_forgot_password')}`);
    }

    return result;
  };

  const selectOption = (type) => {
    if (type === 'username') {
      setIsusername(true);
      setMobile('');
    } else {
      setIsusername(false);
      setUserName('');
    }
  };

  // handle Value
  const handleChange = (e) => {
    const { value } = e.target;
    if (/^\+?\d*$/.test(value)) {
      setMobile(value);
    }
  };

  const handlesubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      // Call validate() function here
      await putAsync('EP_UserAuthentication/EP_User_ForgetPasswordLink', body)
        .then((res) => {
          if (res.statusCode === 200) {
            const link = `${reactURL}/changepassword/${res?.data[0]?.forgetGUID}`;
            console.log('send', link);
            handleSendEmail(link, res?.data[0]);
          } else {
            toast.error(`${mobile}  ${res.message}`);
          }
        })
        .catch((err) => {
          toast.error(t('Something went wrong, Please try again!'));
        });
    }
  };
  const handleSendEmail = async (link, data) => {
    const emailData = {
      username: data.userName,
      forgotLink: link,
      email: data.email,
      mobile: data.mobile,
      linkType: 1,
      message: '',
    };

    if (data) {
      // Call validate() function here
      await postAsync('EP_UserAuthentication/SendResetPasswordtLink', emailData)
        .then((res) => {
          // toast.success(t('Successfully Send link for change password'));
          toast.success(
            t('Reset Password link has been sent to your registered email. Please check your email to proceed.'),
          );
        })
        .catch((err) => {
          console.log(err, 'error');
          toast.error(t('Something went wrong, Please try again!'));
        });
    }
  };
  useEffect(() => {
    localStorage.setItem('isHome', true);
  });
  return (
    <div data-aos="zoom-in" data-aos-easing="linear" data-aos-duration="1500" className="pt-12 xl:pt-28 items-center">
      <div
        className="py-10"
        style={{
          background: `transparent url('./assets/Sharjah-stroke-logo-1.png') left top 0px no-repeat`,

          width: '100%',
        }}
      >
        {' '}
      </div>
      <div className="container-fluid ">
        <div className="row justify-center items-center">
          <div className="col-sm-6 col-lg-4  ">
            <form className=" px-4 py-5">
              <div className="card rounded-4xl shadow-customgreen bg-green-50">
                <div className="card-body">
                  <div className="row justify-center items-center">
                    <div className="col-lg-4 flex justify-center">
                      <div className="w-24 h-24 mb-3 flex items-center justify-center rounded-full border-2 border-customgreen">
                        <svg
                          version="1.0"
                          xmlns="http://www.w3.org/2000/svg"
                          width="50.000000pt"
                          height="50.000000pt"
                          viewBox="0 0 290.000000 350.000000"
                          preserveAspectRatio="xMidYMid meet"
                        >
                          {' '}
                          <g
                            transform="translate(0.000000,300.000000) scale(0.050000,-0.050000)"
                            fill="#1d8b4b"
                            stroke="none"
                          >
                            {' '}
                            <path d="M2680 5960 c-187 -44 -329 -94 -420 -149 -38 -23 -97 -55 -129 -71 -110 -55 -416 -382 -498 -530 -629 -1145 264 -2509 1542 -2356 1139 136 1749 1342 1192 2356 -82 148 -388 475 -498 530 -32 16 -90 48 -129 72 -266 161 -728 226 -1060 148z" />{' '}
                            <path d="M2370 2467 c-1099 -158 -1942 -1062 -1985 -2129 l-10 -251 55 -44 55 -43 2515 0 2515 0 55 43 55 44 -10 251 c-31 769 -460 1444 -1195 1876 -103 60 -365 158 -560 209 -164 42 -1273 75 -1490 44z" />{' '}
                          </g>{' '}
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="row justify-center items-center">
                    <div className="col-lg-6 w-auto text-center">
                      <h2 className="text-xl text-customgreen  font-semibold">{t('Restore Password')}</h2>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6">
                      <label>
                        <input
                          style={{ marginRight: '5px' }}
                          type="radio"
                          name="userType"
                          className="w-4 h-4  border border-customgreen text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen m-3 block"
                          //value={existingCampaign}
                          onClick={(e) => selectOption('username')}
                        />
                        {t('username')}
                      </label>
                    </div>
                    <div className="col-lg-6">
                      <label>
                        <input
                          style={{ marginRight: '5px' }}
                          type="radio"
                          name="userType"
                          defaultChecked
                          className="w-4 h-4  border border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen m-3 block"
                          //value={existingCampaign}
                          onClick={(e) => selectOption('mobile')}
                        />
                        {t('Mobile')}
                      </label>
                    </div>
                  </div>

                  {!isusername ? (
                    <div className="form-group">
                      <input
                        value={mobile}
                        // onChange={(e) => setMobile(e.target.value)}
                        onChange={handleChange}
                        placeholder={t('Mobile')}
                        className="border border-customgreen focus:ring-customgreen text-gray-900 text-sm rounded-lg  block w-full p-2.5"
                        type="text"
                        name="mobile"
                        min="0"
                      />
                      <p className="mt-2 text-sm">{t('Your mobile number should starts with +971.')}</p>
                    </div>
                  ) : (
                    <div className="form-group">
                      <input
                        value={userName}
                        onChange={(e) => setUserName(e.target.value)}
                        placeholder={t('username')}
                        className=" border border-customgreen focus:ring-customgreen text-gray-900 text-sm rounded-lg  block w-full p-2.5"
                        type="text"
                        name="username"
                      />
                    </div>
                  )}
                </div>
                <div className="card-footer flex items-center w-full gap-1 flex-col xl:flex-row lg:justify-evenly ">
                  <button
                    onClick={handlesubmit}
                    type="submit"
                    className="text-white bg-customgreen hover:bg-hovergreen w-36 focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-2 py-2 text-center"
                  >
                    {t('Restore Password')}
                  </button>{' '}
                  <Link to={'/donorLogin'} className=" w-36">
                    <button className="text-white bg-customgreen hover:bg-hovergreen   focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-3 py-2 text-center">
                      {t('Back')}
                    </button>
                  </Link>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
